<template>
    <v-app id="app">
        <app-alerts/>
        <router-view/>
    </v-app>
</template>


<script>
    import AppAlerts from './components/AppAlerts';

    export default {
        name: 'App',
        components: {
            AppAlerts
        },

        created() {

        },

        computed: {}
    }

</script>

<style>
    .place-list td {
        cursor: pointer;
    }
</style>
